<template>
    <div class="regular fullBg">
        <div class="rightWeekData ">
            <div class="headP">
                <p class="img"><img
                        :src="infoMesData?infoMesData.avatar:require('@/assets/img/updateImg/playerHead.png')" alt="">
                </p>
                <p class="name">
                    <span class="zh">{{infoMesData?infoMesData.name:''}}</span>
                    <span class="en">{{infoMesData?infoMesData.nameEn:''}}</span>
                </p>
                <p class="position">
                    <img src="../assets/img/playerImg/staffPosition.svg" alt="">
                    <i>{{infoMesData && infoMesData.title ?titMsg(infoMesData.title):''}}</i>
                </p>
                <p class="playerMsg">
                    <span class="star">{{barDate}}</span>
                </p>
            </div>
            <div id="networkDiagram" class="message" style="height: 12vw;width:35vw;"></div>
            <div class="barTit">
                <span v-if="dateBar && dateBar.infoData ? otherPlayer.indexOf(dateBar.infoData.userTitle) < 0 : ''" v-for="item in colorObj">
                   <span class="titCol"
                         :style="{background: 'linear-gradient(180deg,'+item.start+' 0%, '+item.end+' 100%)'}"></span>
                <span class="titLab">{{item.name}}</span>
                </span>
                <span v-if="dateBar && dateBar.infoData ? otherPlayer.indexOf(dateBar.infoData.userTitle) >= 0 : ''" v-for="item in barColorOther">
                   <span class="titCol"
                         :style="{background: 'linear-gradient(180deg,'+item.start+' 0%, '+item.end+' 100%)'}"></span>
                <span class="titLab">{{item.name}}</span>
                </span>
            </div>
            <div id="weekBar" style="height: calc(100% - 11vw);  width: 90%;"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "assessmentReportDetail",
        props: {
            // trainingReportId: String
        },
        data() {
            return {
                trainingReportId: this.$route.params.id,//球员id
                seasonId: this.$route.params.seasonId,//赛季id
                // seasonId: '5f2ba38c923b9753b315f0b9',//赛季id
                // trainingReportId: '5f09beab2bbde45f19a0558d',//球员id
                allTit: [],//
                infoMesData: null,//初始化的数据
                playersReportList: null,//球员获取评估项

                workDiagram: {},//雷达图各项数据
                dateBar: {},//柱状图各项数据
                barLin: 55,//柱状图显示个数
                barDate: '',//柱状图时间

                timeInfo: null,//定时器--首次加载
                timer: null,//定时器--间隔加载

                otherPlayer: ['doctor', 'interpretor', 'teamManager'],//队医，翻译，梯队经理评估
                colorObj: [
                    {
                        name: '训练/比赛组织',
                        start: "#2979FF",
                        end: "#42A5F5",
                    },
                    {
                        name: '交流方式',
                        start: "#AD6BEA",
                        end: "#C186F2",
                    }, {
                        name: '知识储备',
                        start: "#34C955",
                        end: "#85C934",
                    }, {
                        name: '行为举止',
                        start: "#FFB23E",
                        end: "#FFD02B",
                    }, {
                        name: '心态',
                        start: "#E55045",
                        end: "#E98680",
                    },{
                        name: '其他',
                        start: "#979797",
                        end: "#B4B4BB",
                    },
                ],


                barColorOther: [ {
                    name: '职位核心价值',
                    start: "#2979FF",
                    end: "#42A5F5",
                },
                    {
                        name: '岗位实践情况',
                        start: "#AD6BEA",
                        end: "#C186F2",
                    }, ],
            }
        },
        mounted() {
            this.infoFn();
            this.tit();
        },
        watch: {},
        methods: {
            tit(){
                this.$server.commonDataTit({key:'title'})
                    .then((res)=>{
                        this.allTit=res.data;
                    })
            },
            titMsg(str){
                console.log(str)
                for (let i=0;i<this.allTit.length;i++){
                    if(this.allTit[i].key==str){
                        return this.allTit[i].value
                    }
                }
            },
            //初始化数据
            infoFn() {
                let data = {
                    id: this.trainingReportId,//球员id
                    info: 'staffPersonal'
                }
                this.$server.getUserMsg(data).then((res) => {
                    this.infoMesData = res.data;
                    // console.log(this.infoMesData)
                    //柱状图
                    data = {
                        playerId: this.trainingReportId,//球员id
                        start: new Date().getFullYear()+'/01/01',
                        end: this.$global.formatDate(new Date(), 'yyyy/MM/dd', true),
                    }
                    this.$server.getPlayersReportWeekAll(data).then((res) => {
                        // this.playersReportList = res.data;
                        this.weekBarData(res.data);
                    });
                    this.$parent.$parent.imgAi(this.$imgJson.handAiImgArr);
                    this.$parent.$parent.audioPlayFn(this.$global.audioPlayUrl("这是" + this.infoMesData.name + this.$global.randomFn(this.$aiJson.playVoice.reportDetail)), true, false)
                })
            },
            //网络图
            networkDiagram(data) {
                data = JSON.parse(data);
                let indicatorArr = [
                    {name: '训练组织', nameEn: 'organization', max: 4},
                    {name: '交流方式', nameEn: 'communication', max: 4},
                    {name: '知识储备', nameEn: 'knowledge', max: 4},
                    {name: '行为举止', nameEn: 'mindset', max: 4},
                    {name: '心态', nameEn: 'behavior', max: 4},
                    {name: '其他', nameEn: 'others', max: 4},
                ], seriesVal = [data.organization, //训练组织
                    data.communication, //交流方式
                    data.knowledge,//知识储备
                    data.mindset,//行为举止
                    data.behavior,//心态
                    data.others,//其他
                ]
                let myChart = this.$echarts.init(document.getElementById('networkDiagram'));
                myChart.setOption({
                    title: {text: null}, // 隐藏图表标题
                    legend: {enabled: false}, // 隐藏图例
                    tooltip: {
                        trigger: 'axis'
                    },
                    calculable: true,
                    radar: [
                        {
                            splitNumber: 4, // 雷达图圈数设置
                            nameGap: 10, // 图中工艺等字距离图的距离
                            center: ['60%', '60%'], // 图的位置
                            // shape: 'circle',
                            name: {
                                show: true, // 是否显示工艺等文字
                                formatter: (params, value) => {
                                    let num;
                                    let name;
                                    for (let i = 0; i < indicatorArr.length; i++) {
                                        if (indicatorArr[i].name == params) {
                                            num = seriesVal[i];
                                            if (this.$store.state.language == 'en') {
                                                name = indicatorArr[i].nameEn
                                            } else {
                                                name = indicatorArr[i].name
                                            }
                                        }
                                    }
                                    let html = [
                                        '{label|' + name + ' ' + '}{num|' + ' ' + num + '}'
                                    ]
                                    return html;
                                }, // 工艺等文字的显示形式
                                rich: {
                                    label: {
                                        color: '#979797',// 工艺等文字颜色
                                        fontSize: 18
                                    },
                                    num: {
                                        color: '#fff',
                                        fontSize: 24,
                                        fontFamily: 'akrobatBold'
                                    },
                                },
                            },
                            indicator: indicatorArr,
                            axisLine: {            // 坐标轴线
                                show: true,        // 默认显示，属性show控制显示与否
                                lineStyle: {
                                    color: '#383838', // 设置网格的颜色
                                },
                            },
                            splitArea: {
                                show: false,
                            },
                            splitLine: {
                                show: true,
                                lineStyle: {
                                    width: 1,
                                    color: 'rgba(73, 73, 73, 0.54)', // 设置网格的颜色
                                },
                            }
                        }
                    ],
                    series: [
                        {
                            name: '维度数据',
                            type: 'radar',
                            symbol: "none", // 去掉图表中各个图区域的边框线拐点
                            itemStyle: {
                                normal: {
                                    color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                        offset: 1,
                                        color: 'rgba(103, 168, 228, 0.4)'
                                    },
                                    ]),// 图表中各个图区域的边框线拐点颜色
                                    lineStyle: {
                                        color: "#49A8E8" // 图表中各个图区域的边框线颜色
                                    },
                                    areaStyle: {
                                        type: 'default'
                                    }
                                }
                            },
                            data: [
                                {
                                    value: seriesVal,
                                    // value: [2,4,1],
                                    label: {
                                        // show: true,
                                        color: '#ACEC8E',
                                        formatter: (params) => {
                                            return params.value;
                                        }
                                    }
                                },
                            ],
                        }
                    ]
                });
            },
            //柱状图
            weekBarData(data) {
                if (!data.length) {
                    return
                }
                let barWidth = 13;//柱状图默认宽度

                let dateBarArr = data;
                this.dateBar = this.serializationList(dateBarArr[0]);
                console.log(this.dateBar)
                let thisBarDataX = [];//柱状图个数
                for (let i = 0; i < this.barLin; i++) {
                    thisBarDataX.push(i)
                }
                this.positionList(this.dateBar.infoData.show);//问题接口
                // data[data.length].date.split('W')[1]
                // 指定图表的配置项和数据
                let myChart = this.$echarts.init(document.getElementById('weekBar'));
                var labelOption = {
                    show: true,
                    position: 'top',
                    distance: 15,
                    align: 'left',
                    verticalAlign: 'middle',
                    rotate: 90,
                    formatter: (ind) => {
                        // console.log(ind);
                        // console.log(this.playersReportList[this.dateBar.lastShowDataQuestion[ind.dataIndex]])
                        // this.playersReportList[this.dateBar.lastShowDataQuestion[ind.dataIndex]]
                        let title = this.playersReportList[this.dateBar.lastShowDataQuestion[ind.dataIndex]]
                        return title ? ind.value + " " + title.name : ''
                    },
                    fontSize: 12,
                    color: 'rgba(255,255,255,.35)',
                    /* rich: {
                         name: {
                             // textBorderColor: '#fff'
                         }
                     }*/
                };

                myChart.setOption({
                    grid: {
                        x: 40,
                        y: 10,
                        right: 0,
                        top: '20%',
                        borderWidth: 1
                    },
                    //  ------  X轴 ------
                    xAxis: {
                        show: false,  // 是否显示
                        nameGap: 15, // 坐标轴名称与轴线之间的距离
                        nameRotate: 0,  // 坐标轴名字旋转
                        axisLine: {       // 坐标轴 轴线
                            show: true,  // 是否显示
                            // ------   线 ---------
                            lineStyle: {
                                color: '#616162',
                                width: 1,
                                type: 'solid'
                            }
                        },
                        axisTick: {    // 坐标轴 刻度
                            show: false,  // 是否显示
                        },
                        data: thisBarDataX
                    },
                    //   ------   y轴  ----------
                    yAxis: {
                        show: false,  // 是否显示
                        nameTextStyle: {    // 坐标轴名称样式
                            color: '#fff',
                            padding: [5, 0, 0, 5]  // 坐标轴名称相对位置
                        },
                        nameGap: 15, // 坐标轴名称与轴线之间的距离

                        axisLine: {    // 坐标轴 轴线
                            show: true,  // 是否显示
                            // ----- 线 -------
                            lineStyle: {
                                color: '#616162',
                                width: 1,
                                type: 'solid'
                            }
                        },
                        axisTick: {      // 坐标轴的刻度
                            show: true,    // 是否显示
                            inside: true,  // 是否朝内
                            length: 3,      // 长度
                            lineStyle: {
                                color: '#616162',  // 默认取轴线的颜色
                                width: 1,
                                type: 'solid'
                            }
                        },
                        axisLabel: {      // 坐标轴的标签
                            show: true,    // 是否显示
                            inside: false,  // 是否朝内
                            rotate: 0,     // 旋转角度
                            margin: 8,     // 刻度标签与轴线之间的距离
                            color: '#fff',  // 默认轴线的颜色
                        },
                        splitLine: {    // gird 区域中的分割线
                            show: true,   // 是否显示
                            lineStyle: {
                                color: '#666',
                                width: 1,
                                type: 'solid'
                            }
                        },
                    },
                    //  -------   内容数据 -------
                    series: [
                        {
                            type: 'bar',      // 类型
                            label: labelOption,
                            itemStyle: {    // 图形的形状
                                normal: {
                                    //柱形图圆角，初始化效果
                                    barBorderRadius: [3, 3, 0, 0],
                                    color: this.barColorFn
                                }
                            },
                            barWidth: barWidth,  // 柱形的宽度
                            barGap: '10%',
                            // barCategoryGap: '20%',  // 柱形的间距

                            data: thisBarDataInfo,
                            markLine: {
                                symbol: ['none', 'none'],//去掉箭头
                                lineStyle: {
                                    type: 'dotted',
                                    color: 'rgba(207, 212, 217, .36)'
                                },
                                label: {
                                    // position: 'insideStartTop'
                                },
                                data: [
                                    {type: 'average', name: '平均值'}
                                ]
                            },//平均线
                        }
                    ]
                });
                //初始数据
                var thisBarDataInfo = [];//第一次加载
                let indInfo = 0;
                clearInterval(this.timeInfo);
                this.timeInfo = null;
                this.timeInfo = setInterval(() => {
                    if (this.dateBar.lastShowData[indInfo]) {//判断当前位置
                        thisBarDataInfo.push(this.dateBar.lastShowData[indInfo]);
                        // console.log(thisBarDataInfo)
                        indInfo++

                        myChart.setOption({
                            series: [
                                {
                                    data: thisBarDataInfo
                                }
                            ],
                        });
                    } else {
                        clearInterval(this.timeInfo)
                    }

                }, 90)
                // alert(this.otherPlayer.indexOf(this.dateBar.infoData.userTitle))
                this.otherPlayer.indexOf(this.dateBar.infoData.userTitle) < 0 ? this.networkDiagram(this.workDiagram) : '';
                //间隔变换数据
                clearInterval(this.timer);
                this.timer = setInterval(() => {
                    barWidth == 5 ? barWidth = 13 : barWidth = 5;
                    myChart.setOption({
                        series: [
                            {
                                barWidth: barWidth,  // 柱形的宽度
                            }
                        ],
                    });
                    let barShowTime = null;
                    barShowTime = setTimeout(() => {
                        if (dateBarArr.indexOf(this.dateBar.infoData) == (dateBarArr.length - 1)) {
                            this.dateBar = this.serializationList(dateBarArr[0])
                        } else {
                            this.dateBar = this.serializationList(dateBarArr[dateBarArr.indexOf(this.dateBar.infoData) + 1])
                        }
                        this.otherPlayer.indexOf(this.dateBar.infoData.userTitle) < 0 ? this.networkDiagram(this.workDiagram) : '';
                        this.positionList(this.dateBar.infoData.show);//问题接口
                        let thisBarData = [];
                        let time = null;
                        let ind = 0;
                        time = setInterval(() => {
                            if (this.dateBar.lastShowData[ind]) {
                                thisBarData.push(this.dateBar.lastShowData[ind]);
                                ind++

                                myChart.setOption({
                                    series: [
                                        {
                                            itemStyle: {    // 图形的形状
                                                normal: {
                                                    // color: '#81B5FF'
                                                    //柱形图圆角，初始化效果
                                                    barBorderRadius: [2, 2, 0, 0],
                                                    color: this.barColorFn
                                                }
                                            },
                                            barWidth: barWidth,  // 柱形的宽度
                                            data: thisBarData
                                        }
                                    ],
                                });
                            } else {
                                clearInterval(time)
                            }

                        }, 90)
                    }, 1000);
                }, 10000)
            },
            //颜色
            barColorFn(params) {
                // console.log(this.otherPlayer.indexOf(this.dateBar.infoData.userTitle));
                let organizationInd = 0, communicationInd = 0, knowledgeInd = 0, behaviorInd = 0, mindsetInd = 0, othersInd = 0;
                let coreInd = 0, exerciseInd = 0;
                let thisBarData = this.dateBar.thisBarData.length;
                if(this.otherPlayer.indexOf(this.dateBar.infoData.userTitle) < 0) {
                    organizationInd = (this.dateBar.organization.length - 1);
                    communicationInd = organizationInd + this.dateBar.communication.length;
                    knowledgeInd = communicationInd + this.dateBar.knowledge.length;
                    behaviorInd = knowledgeInd + this.dateBar.behavior.length;
                    mindsetInd = behaviorInd + this.dateBar.mindset.length;
                    othersInd = mindsetInd + this.dateBar.others.length;

                } else {
                    coreInd = (this.dateBar.core.length - 1);
                    exerciseInd = coreInd + this.dateBar.exercise.length;
                }

                for (let i = 0; i < Math.ceil(this.barLin / this.dateBar.thisBarData.length); i++) {
                    if(this.otherPlayer.indexOf(this.dateBar.infoData.userTitle) < 0) {
                        if (params.dataIndex <= (thisBarData * i + organizationInd)) {
                            return new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                offset: 1,
                                color: '#2979FF'
                            },
                                {
                                    offset: 0,
                                    color: '#42A5F5'
                                }])
                        } else if (params.dataIndex > (thisBarData * i + organizationInd) && params.dataIndex <= (thisBarData * i + communicationInd)) {
                            // return '#F3C74E'
                            return new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                offset: 1,
                                color: '#AD6BEA'
                            },
                                {
                                    offset: 0,
                                    color: '#C186F2'
                                }])
                        } else if (params.dataIndex > (thisBarData * i + communicationInd) && params.dataIndex <= (thisBarData * i + knowledgeInd)) {
                            return new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                offset: 1,
                                color: '#34C955'
                            },
                                {
                                    offset: 0,
                                    color: '#85C934'
                                }])
                        } else if (params.dataIndex > (thisBarData * i + knowledgeInd) && params.dataIndex <= (thisBarData * i + behaviorInd)) {
                            return new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                offset: 1,
                                color: '#FFB23E'
                            },
                                {
                                    offset: 0,
                                    color: '#FFD02B'
                                }])
                        } else if (params.dataIndex > (thisBarData * i + (behaviorInd)) && params.dataIndex <= (thisBarData * i + mindsetInd)) {
                            return new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                offset: 1,
                                color: '#E55045'
                            },
                                {
                                    offset: 0,
                                    color: '#E98680'
                                }])
                        } else if (params.dataIndex > (thisBarData * i + (mindsetInd)) && params.dataIndex <= (thisBarData * i + othersInd)) {
                            return new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                offset: 1,
                                color: '#979797'
                            },
                                {
                                    offset: 0,
                                    color: '#B4B4BB'
                                }])
                        }
                    } else {
                        if (params.dataIndex <= (thisBarData * i + coreInd)) {
                            return new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                offset: 1,
                                color: '#2979FF'
                            },
                                {
                                    offset: 0,
                                    color: '#42A5F5'
                                }])
                        } else if (params.dataIndex > (thisBarData * i + coreInd) && params.dataIndex <= (thisBarData * i + exerciseInd)) {
                            // return '#F3C74E'
                            return new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                offset: 1,
                                color: '#AD6BEA'
                            },
                                {
                                    offset: 0,
                                    color: '#C186F2'
                                }])
                        }
                    }
                }
            },
            //问题渲染
            positionList(scale) {
                let data = JSON.parse(scale);
                console.log(data)
                let arr = [];
                for (let i = 0; i < data.length; i++) {
                    if (data[i].child && data[i].child.length) {
                        // console.log(data[i].child)
                        if(this.otherPlayer.indexOf(this.dateBar.infoData.userTitle) < 0) {
                            for (let j = 0; j < data[i].child.length; j++) {
                                if(data[i].child[j].child && data[i].child[j].child.length) {
                                    arr = arr.concat(data[i].child[j].child)
                                }
                            }
                        }else {
                            arr = arr.concat(data[i].child)
                        }

                    }
                }
                // console.log(arr)
                this.playersReportList = this.positionScreen(arr.length ? arr : data);

            },
            //数据分类
            serializationList(list) {
                let data = JSON.parse(list.item);
                let thisBarData = [];//得分数组
                let thisBarDataQuestion = [];//评估项
                this.barDate = list.date;
                this.workDiagram = list.mean;

                let knowledge = [], organization = [], communication = [], behavior = [], mindset = [], others = [];//评估分数
                let core = [], exercise = [];
                let knowledgeQuestion = [], organizationQuestion = [], communicationQuestion = [], behaviorQuestion = [],
                    mindsetQuestion = [], othersQuestion = [], coreQuestion = [], exerciseQuestion = [];//评估项问题
                let obj = {};
                if(this.otherPlayer.indexOf(list.userTitle) < 0) {
                    for (var key in data) {
                        if (key.split('_')[0] == 'organization') {
                            organization.push(data[key])
                            organizationQuestion.push(key)
                        } else if (key.split('_')[0] == 'communication') {
                            communication.push(data[key])
                            communicationQuestion.push(key)
                        } else if (key.split('_')[0] == 'knowledge') {
                            knowledge.push(data[key])
                            knowledgeQuestion.push(key)
                        } else if (key.split('_')[0] == 'behavior') {
                            behavior.push(data[key])
                            behaviorQuestion.push(key)
                        } else if (key.split('_')[0] == 'mindset') {
                            mindset.push(data[key])
                            mindsetQuestion.push(key)
                        } else if (key.split('_')[0] == 'others') {
                            others.push(data[key])
                            othersQuestion.push(key)
                        }
                    }

                    //真实数据
                    thisBarData = thisBarData.concat(organization)
                        .concat(communication)
                        .concat(knowledge)
                        .concat(behavior)
                        .concat(mindset)
                        .concat(others);
                    thisBarDataQuestion = thisBarDataQuestion.concat(organizationQuestion)
                        .concat(communicationQuestion)
                        .concat(knowledgeQuestion)
                        .concat(behaviorQuestion)
                        .concat(mindsetQuestion)
                        .concat(othersQuestion);

                    obj = {
                        knowledge: knowledge,//知识储备
                        organization: organization,//训练组织
                        communication: communication,//交流方式
                        behavior: behavior,//心态
                        mindset: mindset,//行为举止
                        others: others,//其他
                    }
                } else {
                    for (var key in data) {
                        if (key.split('_')[0] == 'core') {
                            core.push(data[key])
                            coreQuestion.push(key)
                        } else if (key.split('_')[0] == 'exercise') {
                            exercise.push(data[key])
                            exerciseQuestion.push(key)
                        }
                    }

                    //真实数据
                    thisBarData = thisBarData.concat(core)
                        .concat(exercise)
                    thisBarDataQuestion = thisBarDataQuestion.concat(coreQuestion)
                        .concat(exerciseQuestion)

                    obj = {
                        core: core,//职位核心价值
                        exercise: exercise,//岗位实践情况
                    }

                }

                //累加柱状图显示数据
                let lastShowData = [];
                let lastShowDataQuestion = [];
                if (thisBarData.length < this.barLin) {//向上取整显示柱状图
                    // console.log(this.barLin/thisBarData.length)
                    for (let i = 0; i < Math.ceil(this.barLin / thisBarData.length); i++) {
                        lastShowData = lastShowData.concat(thisBarData)
                        lastShowDataQuestion = lastShowDataQuestion.concat(thisBarDataQuestion)
                    }
                }
                // console.log(lastShowData)
                // console.log(organization)
                // console.log(communication)
                // console.log(Personality)
                // console.log(thisBarData);
                // console.log(list);

                return {
                    ...obj,
                    thisBarData: thisBarData,//数据
                    thisBarDataQuestion: thisBarDataQuestion,//数据对应的评估项
                    lastShowData: lastShowData,//显示数据
                    lastShowDataQuestion: lastShowDataQuestion,//显示数据对应的评估项
                    infoData: list,//原始数据
                }
            },
            //问题分类
            positionScreen(data) {
                let map = {}
                for (let i = 0; i < data.length; i++) {
                    map[data[i].key] = data[i]
                }
                console.log(map);
                return map
            }
        },
        destroyed() {
            clearInterval(this.timer);
            clearInterval(this.timeInfo);
        }
    }
</script>

<style scoped lang="less">
    .fullBg {
        background-image: url("../assets/img/updateImg/bg3.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }

    .rightWeekData {
        /*padding-left: 3vw;*/
        box-sizing: border-box;
        float: left;
        position: relative;
        width: 75%;
        height: calc(100% - 8vw);
        display: inline-block;
        margin-bottom: 3vw;
        padding: 5vw 8vw 0 5vw;
        color: #fff;
    }

    .barTit {
        /*position: absolute;*/
        /*top: 14vw;*/
        /*right: 5vw;*/
        padding-bottom: 1vw;
        margin-right: 1vw;
        margin-top: 3vw;
        font-size: 22px;

        span {
            /*float: right;*/
        }

        .titCol {
            width: 20px;
            height: 20px;
            display: inline-block;
        }

        .titColXingGe {
            background: #F3C74E;
        }

        .titColJiShu {
            background: #71ABFB;
        }

        .titColZhanShu {
            background: #4BCC6E;
        }

        .titLab {
            font-family: PingFang;
            color: #fff;
            padding-left: .5vw;
            padding-right: 1.5vw;
            margin-top: -8px;
        }
    }

    .message {
        position: absolute;
        right: 14%;
        top: 10%;
    }

    .headP {
        font-size: 44px;
        margin-top: 3vw;
        height: 8vw;
        /*line-height: 8vw;*/
        background-size: auto 100%;
        background-repeat: no-repeat;
        position: relative;

        .img {
            float: left;
            width: 7vw;
            height: 7vw;
            overflow: hidden;
            border-radius: 50%;
            background-color: rgba(12, 12, 13, 1);

            img {
                width: 100%;
            }
        }

        .name {
            padding-left: 3vw;
            float: left;
            font-family: PingFangMedium;
            text-align: left;

            span {

            }

            span.zh {
                display: block;
                font-weight: bolder;
                font-size: 60px;
                background: linear-gradient(180deg, #FFFFFF 0%, #CAC9C9 200%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
            }

            span.en {
                display: block;
                font-size: 30px;
                background: linear-gradient(180deg, rgba(255, 255, 255, .6) 0%, rgba(202, 201, 201, .6) 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
            }
        }

        .position{
            float: left;
            margin-left: 2vw;
            margin-top: 1.5vw;
            font-size: 24px;
            padding-left: .5vw;
            padding-right: .5vw;
            background: #42A5F5;
            border-left: 4px solid #276EA7;
            border-top: 4px solid #276EA7;
            border-bottom: 4px solid #276EA7;
            position: relative;
            /*box-sizing: border-box;*/
            i {
                height: 2vw;
                line-height: 2vw;
                font-style: normal;
            }
            img {
                position: absolute;
                right: -0.9vw;
                top: -4px;
                height: calc(100% + 8px);
            }
        }

        .playerMsg {
            position: absolute;
            right: -7vw;
            top: 3vw;
            margin-left: 2vw;
            text-align: left;
            margin-top: 1.5vw;

            .star {
                background-image: url("../assets/img/playerImg/bg1.svg");
                background-size: 100% 100%;
                padding-right: 5vw;
                padding-left: 1vw;
                height: 2.5vw;
                line-height: 2.5vw;
                width: 16vw;
                display: inline-block;
                font-size: 26px;
                font-family: PingFangMedium;
                color: rgba(255, 255, 255, .8);
            }

        }

    }


</style>
